import { render, staticRenderFns } from "./MetricsDataPage.vue?vue&type=template&id=62758a59&scoped=true&"
import script from "./MetricsDataPage.vue?vue&type=script&lang=js&"
export * from "./MetricsDataPage.vue?vue&type=script&lang=js&"
import style0 from "./MetricsDataPage.vue?vue&type=style&index=0&id=62758a59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62758a59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62758a59')) {
      api.createRecord('62758a59', component.options)
    } else {
      api.reload('62758a59', component.options)
    }
    module.hot.accept("./MetricsDataPage.vue?vue&type=template&id=62758a59&scoped=true&", function () {
      api.rerender('62758a59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/monitoring/MetricsDataPage.vue"
export default component.exports